import { render, staticRenderFns } from "./garage.vue?vue&type=template&id=b0f4de4c&scoped=true"
import script from "./garage.vue?vue&type=script&lang=js"
export * from "./garage.vue?vue&type=script&lang=js"
import style0 from "./garage.vue?vue&type=style&index=0&id=b0f4de4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4de4c",
  null
  
)

export default component.exports